import {AttioIcon, IntegrationCard} from "@tinct/web-components";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useDeleteCrmIntegration, useGetOrganizationById} from "@tinct/core-api";
import {useMemo} from "react";
import {useOAuthPopup} from "../pages/edit-integrations-page/hooks/use-oauth-popup";

export const AttioIntegration = () => {
  const workspaceId = useGetCurrentWorkspaceId();

  const { mutate: deleteCrmIntegration } = useDeleteCrmIntegration();
  const { openOAuthPopup } = useOAuthPopup({
    organizationId: workspaceId,
    provider: 'attio',
  });

  const { data: organization } = useGetOrganizationById({
    id: workspaceId,
    fields: {
      crmIntegrations: {
        fields: {
          id: null,
          providerType: null,
          status: null,
          errorDetails: null,
        }
      }
    }
  }, {
    enabled: !!workspaceId,
  });

  const attioIntegration = useMemo(() => {
    return organization?.crmIntegrations?.find(integration => integration.providerType === 'attio');
  }, [organization]);

  const connected = !!attioIntegration;

  const handleDisconnectAttio = () => {
    if (!workspaceId || !attioIntegration?.id) return;
    deleteCrmIntegration({
      integrationId: attioIntegration.id,
      organizationId: workspaceId,
    })
  }

  return <IntegrationCard
    title="Attio"
    description="Enrich companies and sync visitor engagement to your CRM"
    status={connected ? "connected" : "not-connected"}
    icon={<AttioIcon width={40} height={40}/>}
    active={true}
    enabled={connected}
    onEnabledChange={(enabled) => {
      if (enabled) {
        openOAuthPopup();
      } else {
        handleDisconnectAttio();
      }
    }}
  />
}
